export default __webpack_public_path__ + "static/media/regularalumno.3d274da5.jpg";